


import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";
import Sprite = PIXI.Sprite;
import Texture = PIXI.Texture;
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Timeline, TimelineLite} from "gsap";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";

export class HarlequinScatterCollectorView extends BaseView {

    private _layer:ScalableLayer;
    private _indicatorWrapper:Sprite;

    private _newCollectorGroup: {
        left: {
            active:boolean
            indicator:Sprite
        },
        middle: {
            active:boolean
            indicator:Sprite
        },
        right: {
            active:boolean
            indicator:Sprite
        }
    };
    private _baseGameHeadAnimations:string [] = [
        "HeadActive1",
        "HeadActive2",
        "HeadActive3"
    ];


    private _locked:boolean = false;
    private _litCount:number = 0;
    private _plusOnePositions:number [][] = [];


    private _soundCounter:number = 0;

    public set soundCounter(value:number) {
        this._soundCounter = value;
        this._soundCounter %= 2;
    }
    public get soundCounter():number {
        return this._soundCounter;
    }

    public getScatterLandingSound(baseGame:boolean):string {
        let sound = HarlequinSoundConfig.instance.SCATTER_FS_LAND;
        if (baseGame){
            sound =  HarlequinSoundConfig.instance.SCATTER_LAND[this.soundCounter];
            this.soundCounter += 1;
        }
        return sound;
    }


    public addToPlusOnePosition(arr:number []):void {
        this._plusOnePositions.push(arr);
    }

    public playDelayedPlusOnePositions(fsCounter:number):Timeline {
        const tl:TimelineLite = new TimelineLite();
        let counter:number = fsCounter;

        //tl.add(this.resetIndicators(0, false));

        tl.add([
            () => HarlequinGameModuleConfig.harlequinSignView.resetHeadSpine(),
            //HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("New3ScattersReset")
        ]);
        this._plusOnePositions.forEach((position:number [], index) => {

            tl.add([
                (counter > 0)? () =>  {
                    //debugger;
                    SlotGame.keypad.setZeroBetSpinCounter(++counter);
                } : () => {},
                HarlequinGameModuleConfig.plusOneView.createPlusOneForPos(position[0], position[1])
            ], "+=0.2");
            tl.add(() => {
                this.updateIndicator(index, true);
            }, "+=0.25");
        });
        tl.add(() => {
            this._plusOnePositions.length = 0;
        });

        return tl;
    }

    constructor() {
        super();

        this._layer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.COLLECTOR.name);
        this._layer.addChild(this);
    }

    protected createIndicatorSpines():void {
        this._newCollectorGroup = {
            left: {
                active: false,
                indicator: new Sprite()
            },
            middle: {
                active: false,
                indicator: new Sprite()
            },
            right: {
                active: false,
                indicator: new Sprite()
            }
        };

    }


    initAnimations():void {
        this.createIndicatorArea();
        this.visible = false;
    }

    onResize(data:IResizeData):void {

    }

    protected createIndicatorArea():void {
        const wrapper:Sprite = new Sprite();
        wrapper.alpha = 0.8;
        wrapper.anchor.x = 0.5;
        wrapper.x = 627;

        this.addChild(wrapper);
        this._indicatorWrapper = wrapper;

        this.createIndicatorSpines();
    }



    public updateIndicator(index:number, activity:boolean = false, firstFs:boolean = false):void {

        // TODO: BIG TODO, this logic should NOT be handled here any more, as collectors are now inside a spine object owned by sign view
        //debugger;

        //debugger;
        switch(index) {
            case 0: // Left
                this._newCollectorGroup.left.active = activity;
                //if(!restore) {
                    //HarlequinGameModuleConfig.harlequinSignView.playSignSpine("bonusGameFirstScatter");
                    if(!firstFs) {
                        HarlequinGameModuleConfig.harlequinSignView.playRightBar("NewBonusHarlequinSignAppersBonusHarlequin Teese");
                    }
                    HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("NewFirstScatterLanding");
                //}
                //HarlequinGameModuleConfig.harlequinSignView.playHeadSpine(this._baseGameHeadAnimations[0], 0, true);
                break;
            case 1: // Middle
                this._newCollectorGroup.middle.active = activity;
                //if(!restore) {
                    //HarlequinGameModuleConfig.harlequinSignView.playSignSpine("bonusGameSecundScatter");
                    //HarlequinGameModuleConfig.harlequinSignView.playRightBar("NewBonusHarlequinSignAppersBonusHarlequin");
                    if(!firstFs) {
                        HarlequinGameModuleConfig.harlequinSignView.playRightBar("NewBonusHarlequinSignAppersBonusHarlequin Teese");
                    }
                    HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("NewSecundScatterLanding");
                //}
                //HarlequinGameModuleConfig.harlequinSignView.playHeadSpine(this._baseGameHeadAnimations[1], 0, true);
                break;
            case 2: // Right
                this._newCollectorGroup.right.active = activity;

                if(!firstFs) {
                    //HarlequinGameModuleConfig.harlequinSignView.playRightBar("NewBonusHarlequinSignAppersBonusHarlequin Teese");
                    //HarlequinGameModuleConfig.harlequinSignView.playRightBar("NewBonusWonToBonusgameActivatingHarlequinDrop");
                    HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("NewThirdScatterLanding");
                }
                else {
                // NewThirdScatterDefault
                    HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("NewThirdScatterDefault");
                }

                break;
        }
    }

    public resetIndicators(addDelay?:number, onlyLogic:boolean = false):Timeline {
        const tl:TimelineLite = new TimelineLite();
        //console.log("COLLECT VIEW RESET INDICATORS");
        //debugger;
        if(onlyLogic) {
            //debugger;
            HarlequinGameModuleConfig.harlequinSignView.resetHeadSpine();
            this._newCollectorGroup.left.active = false;
            this._newCollectorGroup.middle.active = false;
            this._newCollectorGroup.right.active = false;
            this._litCount = 0;
        }
        else {
            tl.add(() => {
                HarlequinGameModuleConfig.harlequinSignView.resetHeadSpine();
                this._newCollectorGroup.left.active = false;
                this._newCollectorGroup.middle.active = false;
                this._newCollectorGroup.right.active = false;
                this._litCount = 0;
            });
            tl.add(() => {
            }, addDelay);
        }

        return tl;
    }

    public lock():void {
        //debugger;
        this._locked = true;
    }

    public unLock():void {
        //debugger;
        this._locked = false;
    }

    public get isLocked():boolean {
        return this._locked;
    }

}